import {
  decluttifyABTestRouteConfig,
  getABTestConfig,
} from '@/config/abTestConfig'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'

export default function DecluttifyOnboardingOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/onboarding"
      routeConfig={decluttifyABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      variantPathPrefixes={{ v1: 'v1', v2: 'v2' }}
      validVariants={['baseline', 'v1', 'v2']}
    />
  )
}
